import request from '@/utils/request'
const apiPath = '/cust/customerClassify'
const customerClassifyApi = {
  /**
   * 新增【客户分类】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【客户分类】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【客户分类】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【客户分类】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【客户分类】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【客户分类】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【客户分类】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
}
export default customerClassifyApi
